import { IRecruitment, IRecruitmentDashboard, IQualification, ICandidateDashboard, IEtabDashboardAddress } from "@core/models";
import { EXTRA_STATUS, PERMANENT_CANDIDATES_STATUS } from "@core/constants";

export const recruitmentMock = {
  [IRecruitment.id]: "123",
  [IRecruitment.type]: "CDI",
  [IRecruitment.demandType]: "permanent",
  [IRecruitment.candidates]: [],
  [IRecruitment.isBookingExpress]: false,
  [IRecruitment.secondsToExpiration]: 0,
  [IRecruitment.etablissement]: {},
  [IRecruitment.isArchived]: false,
  [IRecruitment.selectedCandidates]: [],
  [IRecruitment.currentCandidates]: [],
  [IRecruitment.ignoredCandidates]: [],
  [IRecruitment.canceledCandidates]: [],
  [IRecruitment.qualificationLabel]: "Serveur",
  [IRecruitment.isFilled]: true,
  [IRecruitment.precisions]: "Lorem ipsum\nDolor si amet",
  [IRecruitment.appliedCandidatesAmount]: 2,
  [IRecruitment.selectedCandidatesAmount]: 4,
  [IRecruitment.ignoredCandidatesAmount]: 1,
  [IRecruitment.isNovicesAllowed]: false,
};

// CONTRAT API RECRUITMENT AE
export const recruitmentAEMock = {
  [IRecruitmentDashboard.demandId]: 12345,
  [IRecruitmentDashboard.wishedCandidateAmount]: 2,
  [IRecruitmentDashboard.timeBeforeExpiration]: 0, // timestamp
  [IRecruitmentDashboard.qualification]: {
    [IQualification.qualificationId]: 1,
    [IQualification.qualificationLabel]: "Serveur",
  },
  [IRecruitmentDashboard.startDate]: "2018-01-01",
  [IRecruitmentDashboard.startTime]: "16:16",
  [IRecruitmentDashboard.endDate]: "2018-01-01",
  [IRecruitmentDashboard.endTime]: "15:25",
  [IRecruitmentDashboard.address]: {
    [IEtabDashboardAddress.postalCode]: "75000",
    [IEtabDashboardAddress.city]: "Paris",
    [IEtabDashboardAddress.street]: "1 rue de la paix",
  },
  [IRecruitmentDashboard.candidates]: [
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1005/300/300",
      [ICandidateDashboard.firstname]: "John",
      [ICandidateDashboard.status]: EXTRA_STATUS.SELECTED,
    },
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1011/300/300",
      [ICandidateDashboard.firstname]: "Jane",
      [ICandidateDashboard.status]: EXTRA_STATUS.CANCELED,
    },
  ],
  [IRecruitmentDashboard.isFilled]: false,
  [IRecruitmentDashboard.isBookingExpress]: false,
  [IRecruitmentDashboard.hasCandidateRefusedBookingExpress]: false,
  [IRecruitmentDashboard.selectedCandidateAmount]: 0,
  [IRecruitmentDashboard.currentCandidateAmount]: 0,
  [IRecruitmentDashboard.type]: "AE",
  [IRecruitmentDashboard.hasStarted]: false,
  [IRecruitmentDashboard.precision]: "string",
};
// CONTRAT API RECRUITMENT INTERIM
export const recruitmentInterimMock = {
  [IRecruitmentDashboard.demandId]: 12345,
  [IRecruitmentDashboard.wishedCandidateAmount]: 2,
  [IRecruitmentDashboard.timeBeforeExpiration]: 22840, // timestamp
  [IRecruitmentDashboard.qualification]: {
    [IQualification.qualificationId]: 1,
    [IQualification.qualificationName]: "Serveur",
  },
  [IRecruitmentDashboard.startDate]: "2018-01-01",
  [IRecruitmentDashboard.startTime]: "16:16",
  [IRecruitmentDashboard.endDate]: "2018-01-01",
  [IRecruitmentDashboard.endTime]: "15:25",
  [IRecruitmentDashboard.address]: {
    [IEtabDashboardAddress.postalCode]: "75000",
    [IEtabDashboardAddress.city]: "Paris",
    [IEtabDashboardAddress.street]: "1 rue de la paix",
  },
  [IRecruitmentDashboard.candidates]: [
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1005/300/300",
      [ICandidateDashboard.firstname]: "John",
      [ICandidateDashboard.status]: EXTRA_STATUS.SELECTED,
    },
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1011/300/300",
      [ICandidateDashboard.firstname]: "Jane",
      [ICandidateDashboard.status]: EXTRA_STATUS.CANCELED,
    },
  ],
  [IRecruitmentDashboard.isFilled]: false,
  [IRecruitmentDashboard.isBookingExpress]: false,
  [IRecruitmentDashboard.hasCandidateRefusedBookingExpress]: false,
  [IRecruitmentDashboard.appliedCandidateAmount]: 1,
  [IRecruitmentDashboard.selectedCandidateAmount]: 1,
  [IRecruitmentDashboard.currentCandidateAmount]: 0,
  [IRecruitmentDashboard.type]: "INTERIM",
  [IRecruitmentDashboard.hasStarted]: false,
  [IRecruitmentDashboard.precision]: "string",
};

// CONTRAT API RECRUITMENT BOOKING EXPRESS
export const recruitmentBEMock = {
  [IRecruitmentDashboard.demandId]: 12344,
  [IRecruitmentDashboard.wishedCandidateAmount]: 2,
  [IRecruitmentDashboard.timeBeforeExpiration]: 0, // timestamp
  [IRecruitmentDashboard.qualification]: {
    [IQualification.qualificationId]: 1,
    [IQualification.qualificationName]: "Serveur - AE",
  },
  [IRecruitmentDashboard.startDate]: "2018-01-01",
  [IRecruitmentDashboard.startTime]: "16:16",
  [IRecruitmentDashboard.endDate]: "2018-01-01",
  [IRecruitmentDashboard.endTime]: "15:25",
  [IRecruitmentDashboard.address]: {
    [IEtabDashboardAddress.postalCode]: "75000",
    [IEtabDashboardAddress.city]: "Paris",
    [IEtabDashboardAddress.street]: "1 rue de la paix",
  },
  [IRecruitmentDashboard.candidates]: [
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1005/300/300",
      [ICandidateDashboard.firstname]: "Jane",
      [ICandidateDashboard.status]: EXTRA_STATUS.CANCELED,
    },
  ],
  [IRecruitmentDashboard.isFilled]: false,
  // cas booking express
  [IRecruitmentDashboard.isBookingExpress]: true,
  [IRecruitmentDashboard.hasCandidateRefusedBookingExpress]: false,
  [IRecruitmentDashboard.selectedCandidateAmount]: 0,
  [IRecruitmentDashboard.currentCandidateAmount]: 0,
  [IRecruitmentDashboard.type]: "AE",
  [IRecruitmentDashboard.hasStarted]: false,
  [IRecruitmentDashboard.precision]: "string",
};

// CONTRAT d'API RECRUITMENT CDI
export const recruitmentPermanentMock = {
  [IRecruitmentDashboard.demandId]: 12346,
  [IRecruitmentDashboard.timeBeforeExpiration]: 0, // timestamp
  [IRecruitmentDashboard.qualification]: {
    [IQualification.qualificationId]: 1,
    [IQualification.qualificationName]: "Barista",
  },
  [IRecruitmentDashboard.address]: {
    [IEtabDashboardAddress.postalCode]: "75000",
    [IEtabDashboardAddress.city]: "Paris",
    [IEtabDashboardAddress.street]: "1 rue de la paix",
  },
  [IRecruitmentDashboard.candidates]: [
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1005/300/300",
      [ICandidateDashboard.firstname]: "Johnny",
      [ICandidateDashboard.status]: PERMANENT_CANDIDATES_STATUS.APPLIED,
    },
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1011/300/300",
      [ICandidateDashboard.firstname]: "John",
      [ICandidateDashboard.status]: PERMANENT_CANDIDATES_STATUS.APPLIED,
    },
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1005/300/300",
      [ICandidateDashboard.firstname]: "Jane",
      [ICandidateDashboard.status]: PERMANENT_CANDIDATES_STATUS.CONTACTED,
    },
  ],
  [IRecruitmentDashboard.selectedCandidateAmount]: 1,
  [IRecruitmentDashboard.currentCandidateAmount]: 0,
  [IRecruitmentDashboard.openToNovice]: true,
  [IRecruitmentDashboard.precision]:
    "Planning:\n- jeudi 15 septembre 2022 de 08:00 à 19:00 (pause 01h00min)\n- vendredi 16 septembre 2022 de 08:00 à 19:00 (pause 01h00min)\n\nTenue:\n- Tablier (couleur : Peu importe)\n- Baskets (couleur : Noir)\n- Chaussures de Sécurité\n- Ustensiles de Cuisine\n\nCommentaire tenue : \n\n\n\n \nDemande numéro:\n- 123735",
  [IRecruitmentDashboard.isUnlocked]: true,
  [IRecruitmentDashboard.type]: "cdi",
};

// CONTRAT API RECRUITMENT MER
export const recruitmentMERMock = {
  [IRecruitmentDashboard.demandId]: 12347,
  [IRecruitmentDashboard.timeBeforeExpiration]: 0, // timestamp
  [IRecruitmentDashboard.qualification]: {
    [IQualification.qualificationId]: 1,
    [IQualification.qualificationName]: "Serveur - MER",
  },
  [IRecruitmentDashboard.startDate]: "2018-01-01",
  [IRecruitmentDashboard.startTime]: "09:24",
  [IRecruitmentDashboard.address]: {
    [IEtabDashboardAddress.postalCode]: "75000",
    [IEtabDashboardAddress.city]: "Paris",
    [IEtabDashboardAddress.street]: "1 rue de la paix",
  },
  [IRecruitmentDashboard.candidates]: [
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1005/300/300",
      [ICandidateDashboard.firstname]: "John",
      [ICandidateDashboard.status]: EXTRA_STATUS.SELECTED,
    },
    {
      [ICandidateDashboard.picture]: "https://picsum.photos/id/1005/300/300",
      [ICandidateDashboard.firstname]: "Jane",
      [ICandidateDashboard.status]: EXTRA_STATUS.CANCELED,
    },
  ],
  [IRecruitment.isFilled]: false,
  [IRecruitmentDashboard.selectedCandidateAmount]: 0,
  [IRecruitmentDashboard.currentCandidateAmount]: 2,
  [IRecruitmentDashboard.type]: "MER",
  [IRecruitmentDashboard.hasStarted]: false,
  [IRecruitmentDashboard.precision]: "string",
  [IRecruitmentDashboard.duration]: "1 JOUR",
};
